import React from 'react';

import { Stack, Text } from '@mantine/core';

import styles from './cellsV2.module.scss';

interface MonitoringCellProps {
  isRemoteMonitored?: boolean;
  isRhythmMonitored?: boolean;
}

/** "Remote Monitored" column: Yes / No, and who monitors (Rhythm or Clinic) when remote. */
export const MonitoringCell: React.FC<MonitoringCellProps> = ({
  isRemoteMonitored,
  isRhythmMonitored
}) => {
  if (isRemoteMonitored === undefined) return <Text className={styles.muted}>—</Text>;
  if (!isRemoteMonitored) return <Text className={styles.cell}>No</Text>;
  return (
    <Stack gap={1}>
      <Text className={styles.cell}>Yes</Text>
      <Text className={styles.sub}>{isRhythmMonitored !== false ? 'Rhythm' : 'Clinic'}</Text>
    </Stack>
  );
};
